import { render, staticRenderFns } from "./ControlSimple.vue?vue&type=template&id=3ed07bf6&"
import script from "./ControlSimple.vue?vue&type=script&lang=js&"
export * from "./ControlSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports